import { useMutation } from '@apollo/client';
import { graphql } from '@gql/gql';
import type {
  MtNotificationMarkAsReadMutation,
  MtNotificationMarkAsReadMutationVariables,
} from '@gql/graphql';
import { MT_NOTIFICATIONS_GET_NOTIFICATIONS } from './useGetNotifications';
import { ACCOUNT_GET_NEW_NOTIFICATIONS_COUNT } from './useNotificationsCount';

export const MT_NOTIFICATION_MARK_AS_READ = graphql(`
  mutation MtNotificationMarkAsRead($notificationId: Int) {
    markAsRead(notificationId: $notificationId)
  }
`);

export const useMarkAsRead = () => {
  const [markAsRead, { error, loading }] = useMutation<
    MtNotificationMarkAsReadMutation,
    MtNotificationMarkAsReadMutationVariables
  >(MT_NOTIFICATION_MARK_AS_READ, {
    refetchQueries: [ACCOUNT_GET_NEW_NOTIFICATIONS_COUNT, MT_NOTIFICATIONS_GET_NOTIFICATIONS],
  });

  return {
    updateNotificationLoading: loading,
    updateNotificationError: error,
    markAllAsRead: markAsRead,
    markAsRead: (id?: number) => {
      markAsRead(id != null ? { variables: { notificationId: id } } : {});
    },
  };
};
